import { useMemo } from 'react';

import { useGlobalFiltersHook } from 'hooks/useGlobalFiltersHook';

import { getFiltersData } from 'components/common/GlobalFilterComponent/GlobalFilterComponent.utils';

import { IFilter } from 'components/Dashboards/Project/Components/CustomDashboard/utils/utils.type';
import { FILTERS_BY_SOURCE_KEY, PILLS_BY_SOURCE_KEY } from 'components/widgets/Utils/constants/utils';

interface FilterOrPillsMapSingleElement {
    [key: string]: (source: Record<string, any>) => any;
}

type FilterOrPillsArray = Array<FilterOrPillsMapSingleElement>;

export const useWidgetPillsAndFilters = ({
    widgetId,
    source,
    latestVersionId,
}: {
    widgetId?: string;
    source: Record<string, any>;
    latestVersionId: number | undefined;
}) => {
    const filters: IFilter[] = useMemo(() => {
        const sourceKeys = Object.keys(source);

        let acc = {};

        for (const key of sourceKeys) {
            const currentFilters = FILTERS_BY_SOURCE_KEY[key] as FilterOrPillsArray;
            const filterNotExistInFiltersMap = !currentFilters;

            if (filterNotExistInFiltersMap) continue;

            currentFilters.forEach((singleFilter) => {
                const newFilterKey = Object.keys(singleFilter)[0];
                const filterFunction = Object.values(singleFilter)[0];
                const newFilterValue = filterFunction?.(source);
                acc = {
                    ...acc,
                    [newFilterKey]: newFilterValue,
                };
            });
        }
        return getFiltersData(acc);
    }, [source]);

    const pillsData = useMemo(() => {
        const sourceKeys = Object.keys(source);
        let acc = {};

        for (const key of sourceKeys) {
            const currentPills = PILLS_BY_SOURCE_KEY[key] as FilterOrPillsArray;
            const pillNotExistInPillsMap = !currentPills;

            if (pillNotExistInPillsMap) continue;

            currentPills.forEach((singlePill) => {
                const newPillKey = Object.keys(singlePill)[0];
                const pillFunction = Object.values(singlePill)[0];
                const newPillValue = pillFunction?.(source);

                acc = {
                    ...acc,
                    [newPillKey]: newPillValue,
                };
            });
        }

        return acc;
    }, [source]);

    const { pillsList: pills } = useGlobalFiltersHook({ widgetId, source: pillsData, latestVersionId });

    return { filters, pills };
};
